export const PHASE = {
  NOT_SUBMITTED: '未提出',
  USER_CONFIRMED: '教育機関担当者確認中',
  MANAGER_CONFIRMED: '教育機関設置者確認中',
  OWNER_CONFIRMED: 'SARTRAS確認中',
  ADMIN_CONFIRMED: 'SARTRAS確認済み',
} as const;

export default PHASE;
